// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1uhVq","requiredAsterisk":"Info_requiredAsterisk__1bWh4"};